import { Router } from "vue-router";
import { removeQueries, updateQueries } from "../../../utils/routing_utils";

let timeout;

/** Filters a list by a string query.
 * @param searchQuery The query input by the user.
 */
export const search = async (
  router: Router,
  searchQuery: string,
  orderBy: string
): Promise<void> => {
  clearTimeout(timeout);
  if (!searchQuery) {
    await removeQueries(router, ["orderBy", "order", "search"]);
    return;
  }
  timeout = setTimeout(async () => {
    await updateQueries(router, {
      search: searchQuery,
      page: "1",
      orderBy: orderBy,
      order: "Asc",
    });
  }, 500);
};
